import React, { Component } from 'react';
import './Overlay.css';
import Icon from '../../Icon';

class Overlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  static getDerivedStateFromProps(props) {
    return {
      open: props.isOpen
    };
  }

  render() {
    const { open } = this.state;
    if (!open) {
      return null;
    }
    return (
      <div className={'overlay'}>
        <div className={'overlay__wrapper'}>
          <div className={'close-btn'} onClick={() => this.props.onClose()}>
            <Icon
              name="base--icons--cross"
              width="20"
              height="20"
              color={'#ccc'}
            />
          </div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Overlay;



// WEBPACK FOOTER //
// ./src/components/content-blocks/LookBook/Overlay.js